import { Card, Checkbox } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { AiGeneratedBox, Stack } from 'commons/components';
import { useAiField, useAiGeneratedValues } from 'commons/hooks';
import { AI_FIELDS } from 'commons/services/AgentChatService/AgentChatActionBusTypes';

interface FreeShippingAndShowInStoreProps {
  freeShipping: boolean;
  published: boolean;
  onChange: ({ name, value }: { name: string; value: boolean }) => void;
  isDigital: boolean;
}

function FreeShippingAndShowInStore({
  freeShipping,
  published,
  onChange,
  isDigital,
}: FreeShippingAndShowInStoreProps): JSX.Element {
  const { t } = useTranslation(Domain.CATALOG);

  const freeShippingField = useAiField<boolean>({
    componentId: AI_FIELDS.PRODUCT_FREE_SHIPPING,
    getValue: () => freeShipping,
    onReplace: (content) => onChange({ name: 'freeShipping', value: content }),
  });

  const showInStoreField = useAiField<boolean>({
    componentId: AI_FIELDS.PRODUCT_PUBLISHED,
    getValue: () => published,
    onReplace: (content) => onChange({ name: 'published', value: content }),
  });

  const freeShippingFieldState = useAiGeneratedValues<boolean>(
    AI_FIELDS.PRODUCT_FREE_SHIPPING,
  );

  const showInStoreFieldState = useAiGeneratedValues<boolean>(
    AI_FIELDS.PRODUCT_PUBLISHED,
  );

  const handleOnChange = (target: HTMLInputElement) => {
    onChange({ name: target.name, value: target.checked });
    target.name === 'freeShipping'
      ? freeShippingFieldState.resetAiGeneratedValues()
      : showInStoreFieldState.resetAiGeneratedValues();
  };

  return (
    <Card title={t('products.detail.moreOptions')}>
      <Stack column align="flex-start">
        {!isDigital && (
          <AiGeneratedBox
            aiGenerated={freeShippingFieldState.isAiGenerated}
            aiGeneratedProps={{ padding: '2' }}
            {...freeShippingField.navigationAttributes}
          >
            <Checkbox
              label={t('products.detail.freeShipping')}
              name="freeShipping"
              checked={freeShipping}
              onChange={(evt) => handleOnChange(evt.target)}
            />
          </AiGeneratedBox>
        )}
        <AiGeneratedBox
          aiGenerated={showInStoreFieldState.isAiGenerated}
          aiGeneratedProps={{ padding: '2' }}
          {...showInStoreField.navigationAttributes}
        >
          <Checkbox
            label={t('products.detail.showInStore')}
            checked={published}
            name="published"
            onChange={(evt) => handleOnChange(evt.target)}
          />
        </AiGeneratedBox>
      </Stack>
    </Card>
  );
}

export default FreeShippingAndShowInStore;
